var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / dining") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B32",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-dining",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6067342,22.2734365 L20.9402421,20.9399285 C21.4778288,20.4065335 21.4611437,19.5314189 20.9069126,19.0188599 L14.4602269,13.0347185 C15.5645382,11.7845548 15.0603218,12.359622 16.168784,11.1053074 C17.6273083,11.9679285 19.2650146,11.8595565 20.6902094,10.4302108 C21.5945026,9.52591759 23.7489595,6.4880442 23.8656333,6.3213557 C24.3573563,5.64625916 23.3864039,4.75445944 22.7738156,5.28370355 L18.8649785,8.66748812 C18.8024703,8.72584538 18.6190967,8.54247175 18.6732623,8.47581263 L21.9570582,4.43776758 C22.4737681,3.80019222 21.5236519,2.86256944 20.8944191,3.37512842 L16.856374,6.65888363 C16.7855233,6.71724088 16.6063413,6.52971632 16.6605069,6.46720814 L20.0442915,2.55837108 C20.5776865,1.94578272 19.6817358,0.974830382 19.0108309,1.4665533 C18.8482934,1.58322711 15.8062284,3.73768404 14.8977842,4.64197726 C13.5101106,6.02965084 13.3350796,7.6465211 14.2268793,9.15921104 C12.9600304,10.2802074 13.4100812,9.88432227 12.2099322,10.9469614 L2.24195211,1.69155835 C1.38767358,0.899788003 0,1.50822543 0,2.67085326 C0,8.24661595 2.33363892,12.001258 9.0011787,12.001258 C9.16064757,12.188974 11.0174133,14.3770858 12.9802566,16.6906948 L13.361059,17.1395537 C15.3309665,19.4615519 17.3042921,21.7880862 17.6898165,22.2442579 C18.2065671,22.7901871 19.0733391,22.8068315 19.6067342,22.2734365 Z M6.33416279,22.2192709 L11.2306373,16.6893719 L8.8720114,13.9056822 L3.11706671,19.0021748 C2.54199954,19.5147338 2.51282092,20.4023419 3.05875015,20.9440795 L4.39225811,22.2775874 C4.93399572,22.819325 5.82575474,22.794338 6.33416279,22.2192709 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDining);
export default __webpack_public_path__ + "static/media/dining.dfcf6e221afd99307fae520563a6b812.svg";
export { ForwardRef as ReactComponent };